import { createListCollection, Flex, Icon, Select } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { sanitizeSelectedSlotFilterValues, sanitizeSlotFilterOptions, SlotFilterSelectOption } from './slotFilterOptions';

type SlotFilterSelectProps = {
	icon: IconType;
	value: string | string[];
	placeholder: string;
	onChange: (value: string | string[]) => void;
	options: SlotFilterSelectOption[];
	multiple?: boolean;
};

export function SlotFilterSelect({
	icon: IconComponent,
	value,
	placeholder,
	onChange,
	options,
	multiple = false,
}: SlotFilterSelectProps) {
	const safeOptions = sanitizeSlotFilterOptions(options);
	const collection = createListCollection({
		items: safeOptions,
	});

	const selectedValues = sanitizeSelectedSlotFilterValues(value, safeOptions);

	return (
		<Flex alignItems="center" gap={1.5} flex="1" minW={0}>
			<Icon as={IconComponent} color="gray.400" />
			<Select.Root
				collection={collection}
				value={selectedValues}
				onValueChange={(details) => {
					if (multiple) {
						onChange(details.value ?? []);
						return;
					}
					onChange(details.value[0] ?? '');
				}}
				multiple={multiple}
				w="full"
				variant="ghost"
				size="sm"
			>
				<Select.HiddenSelect />
				<Select.Control>
					<Select.Trigger>
						<Select.ValueText placeholder={placeholder} />
					</Select.Trigger>
					<Select.IndicatorGroup>
						<Select.ClearTrigger />
						<Select.Indicator />
					</Select.IndicatorGroup>
				</Select.Control>
				<Select.Positioner>
					<Select.Content>
						{collection.items.map((item) => (
							<Select.Item key={item.value} item={item}>
								<Select.ItemIndicator />
								<Select.ItemText>{item.label}</Select.ItemText>
							</Select.Item>
						))}
					</Select.Content>
				</Select.Positioner>
			</Select.Root>
		</Flex>
	);
}
